import { Fragment, useEffect, useRef, useState } from "react";
import { MessageType } from "../../utils/conversationStorage";
import { Container, Message, MobileChatView,  ToggleButton, HighlightedWord, Header, InitialMessageContainer, TypingDots } from "./styles";import arrowIcon from "../../assets/icons/arrow.svg";
import expandIcon from "../../assets/icons/expand.svg"
import logoIcon from "../../assets/icons/logo-lisa-blue.svg";
import { LibrasButtonMenu } from "../LibrasButtonMenu";
import { getAnimationByTokens } from "../../utils/animationHandle";
import { AnimationData } from "../../assets/glb/animations";
import LibrasIcon from "../../assets/icons/libras-icon.svg";
import { splitByHighlights } from "../../utils/highlightKeywords";
import { getScenarios, findScenarioByName, Scenario } from "../../utils/scenarioStorage";


interface AiChatProps {
  messages: MessageType[];
  setAnimation?: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  onMinimizedChange?: (isMinimized: boolean) => void;
  onSubjectClick?: (text: string) => void;
  setOpenAi?: (open: boolean) => void
  isMobile?: boolean
  isTyping?: boolean
  expandTrigger?: number
}


// function formatTime(date: Date): string {
//   return new Date(date).toLocaleTimeString("pt-BR", {
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// }

const AiChat = ({ messages, setAnimation, onMinimizedChange, onSubjectClick, setOpenAi, isMobile, isTyping, expandTrigger }: AiChatProps) => {
  const containerRef = useRef<HTMLDivElement>(null); const [mobileView, setMobileView] = useState<MobileChatView>("medium");
  const [loadingLibrasKey, setLoadingLibrasKey] = useState<"help" | "sent" | null>(null);
  const [scenarios, setScenarios] = useState<Scenario[]>(() => getScenarios());
  const [showMore, setShowMore] = useState(false);
  const [isMinimized, setIsMinimized] = useState(true);
  const touchStartY = useRef<number | null>(null);
  const dragTriggered = useRef(false);
  const isFirstRender = useRef(true);




  const scenarioNames = ["Férias", "Plano de Saúde", "Ponto de Frequeência", "Dell Wellness Hub", "E-Deals", "Optum"]

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartY.current = e.touches[0].clientY;
    dragTriggered.current = false;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (touchStartY.current === null || dragTriggered.current) return;

    const deltaY = e.touches[0].clientY - touchStartY.current;
    const DRAG_THRESHOLD = 40; // px

    if (deltaY > DRAG_THRESHOLD) {
      dragTriggered.current = true;
      collapseView();
    }
  };

  const handleTouchEnd = () => {
    touchStartY.current = null;
    dragTriggered.current = false;
  };

  const toggleMinimized = () => { 
    if(isMobile){
      collapseView();
    }
    else {
      setIsMinimized((prev) => {
        const next = !prev;
        onMinimizedChange?.(next);
        return next;
      });
    }
    
  };

  useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return;
  }
  toggleMinimized();
}, [expandTrigger]);
  

  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === null || e.key === "scenarios") {
        setScenarios(getScenarios());
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages, mobileView]);


  const playLibrasWithLoading = (key: "help" | "sent", glosaText: string) => {
    setLoadingLibrasKey(key);

    const handleStarted = () => {
      setLoadingLibrasKey(null);
      window.removeEventListener("LISA_ANIMATION_STARTED", handleStarted);
    };

    window.addEventListener("LISA_ANIMATION_STARTED", handleStarted, { once: true });

    window.dispatchEvent(new CustomEvent("LISA_INTERRUPT"));

    getAnimationByTokens(glosaText)
      .then((animations) => {
        if (setAnimation) setAnimation(animations);
        window.dispatchEvent(new CustomEvent("LISA_RESUME"));
      })
      .catch(() => {
        setLoadingLibrasKey(null);
      })
      .finally(() => {
        setLoadingLibrasKey(null);
      });
  };



  const renderMessageText = (text: string) => {
    if (scenarioNames.length === 0) return text;
    const parts = splitByHighlights(text, scenarioNames);
    return parts.map((part, i) =>
      i % 2 === 1 ? (
        <HighlightedWord
          key={i}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
            }
          }}
        >
          {part}
        </HighlightedWord>
      ) : (
        <Fragment key={i}>{part}</Fragment>
      )
    );
  };


  const collapseView = () =>
    setMobileView((prev) =>
      prev === "medium" ? "minimized" : "medium"
    );

  const visibleMessages =
    mobileView === "minimized"
      ? messages.slice(-1)
      : messages;
  return (
    <Container ref={containerRef} $mobileView={mobileView}>
      <Header
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <h1>Chat</h1>

        <span>
          <button 
            className="header-icon hint"
            data-hint="Expandir"
            data-hint-placement="top"
            onClick={toggleMinimized}>
            <img src={expandIcon} alt="Expandir chat" style={{ filter: "invert(100%)" }} data-tutorial="expand-icon"/>
          </button>
          <button 
          className="header-icon hint" 
          data-tutorial="minimize-button"
          data-hint="Fechar"
          data-hint-placement="top"
          onClick={() => setOpenAi?.(false)}>
            <img src={arrowIcon} alt="Fechar chat"  />
          </button>
        </span>

      </Header>
      {(messages.length == 0) && (
        <InitialMessageContainer $isMinimized={isMinimized}>
          <section className="initial-message-title">
            <img src={logoIcon} className="logoLisa" alt="Logo Lisa" />
            <h1>Olá, eu sou a Lisa e vou te ajudar com tudo que precisar! <br /> Faça a sua pergunta sobre qualquer assunto abaixo</h1>
            <LibrasButtonMenu
              disabled={loadingLibrasKey === "sent"}
              onClick={() =>
                playLibrasWithLoading(
                  "sent",
                  "OLA MEU NOME LISA VOCE PRECISAR POSSO_AJUDAR"
                )
              }
            >
              {loadingLibrasKey === "sent" ? (
                <span className="btnSpinner" />
              ) : (
                <img src={LibrasIcon} alt="Ícone Libras" />
              )}
            </LibrasButtonMenu>
          </section>
          {/* <section className="initial-message-subjects">
            <div className="subjects-grid">
              {(showMore ? scenarioNames : scenarioNames.slice(0, 2)).map((name) => (
                <button
                  key={name}
                  className="subject-button"
                  onClick={() => onSubjectClick?.(`Me fale sobre ${name}`)}
                >
                  {name}
                </button>
              ))}
              {scenarioNames.length > 2 && (
                <button
                  className="show-more-button"
                  onClick={() => setShowMore(!showMore)}
                >
                  
                  {showMore ? <img src={minimizeIcon} alt="Mostrar menos" aria-hidden="true" className="minimize" /> : <img src={plusIcon} alt="Mostrar mais" aria-hidden="true" />}
                  {showMore ? "Mostrar menos" : "Mostrar mais"}
                </button>
              )}
            </div>
          </section> */}

        </InitialMessageContainer>
      )}

      {visibleMessages.map((msg, index) => {
        return (
          <Message key={index} $sender={msg.sender} $mobileView={mobileView} $isMinimized={isMinimized}>
            <div className="message-content">
              <h3>{msg.sender === "lisa" ? renderMessageText(msg.text) : msg.text}</h3>                {msg.sender === "lisa" ? (
                <LibrasButtonMenu
                  disabled={loadingLibrasKey === "sent"}
                  onClick={() =>
                    playLibrasWithLoading(
                      "sent",
                      (msg.glosas ?? []).join(" ")
                      )
                    }
                  >
                    {loadingLibrasKey === "sent" ? (
                      <span className="btnSpinner" />
                    ) : (
                      <img src={LibrasIcon} alt="Ícone Libras" />
                    )}
                  </LibrasButtonMenu>
                ) : null}
              </div>
              {/* <span className="message-time">{formatTime(msg.time)}</span> */}
            </Message>
          );
        })}
      {isTyping && (
        <Message $sender="lisa" $mobileView={mobileView} $isMinimized={isMinimized}>
          <div className="message-content">
            <TypingDots>
              <span />
              <span />
              <span />
            </TypingDots>
          </div>
        </Message>
      )}
    </Container>
  );
};

export default AiChat;